import StrategyItem from "features/configuration/GeneralConfiguration/ConfigurationItem/StrategyItem/StrategyItem";

export default StrategyItem;
